// Acknowledgement state kept in the store for the shell (components/App reads `acknowledge`).
// The calls of the convention page live in src/api/ackApi.js (whitelisted BFF, no token in the browser).
export const SET_CONVENTION_BY_HASH = 'SET_CONVENTION_BY_HASH';
export const SET_ACKNOWLEDGE_STATUS = 'SET_ACKNOWLEDGE_STATUS';
export const SET_URL_ERROR = 'SET_URL_ERROR';

export const setConventionByHash = ({ data }) => ({ type: SET_CONVENTION_BY_HASH, payload: data })
export const setAcknowledgeStatus = (status) => ({ type: SET_ACKNOWLEDGE_STATUS, status });
export const setUrlError = (error) => ({ type: SET_URL_ERROR, error })
